module.exports = __webpack_public_path__ + "static/bg-b3bfc0803475f90ad74ba9c3601f51c8.png";